module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/credigas-estacionario/detalles/components/gascom/estacionario-gascom.component.scss
// module id = ./src/app/creditos/credigas-estacionario/detalles/components/gascom/estacionario-gascom.component.scss
// module chunks = main